import React from 'react';

function SuccessModal({ onClose, count }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="success-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>

        <h2>Selection Submitted!</h2>
        <p>
          Your selection of {count} item{count !== 1 ? 's' : ''} has been saved successfully.
        </p>

        <button onClick={onClose}>
          Continue Shopping
        </button>
      </div>
    </div>
  );
}

export default SuccessModal;
